import { _ } from "extensions/underscore";

import { accounting } from "common/utils";

export const approval_rate = ({ by }) => _.partial(accounting.authorizations.approvalRate, _, { by });

export const decline_rate = ({ by }) => _.partial(accounting.authorizations.declineRate, _, { by });

export const auth_count = ({ by }) => _.partial(accounting.authorizations.authCount, _, { by });

export const chargeback_rate = () => _.partial(accounting.chargebacks.chargebackRate, _);

export const fee_rate = () => accounting.fees.grossEffectiveRate;

export const total_amount = () => accounting.sales.netAmount;

export const transactions_count = () => function(model) {
    return accounting.refunds.getTotalValue(model, "count") + accounting.sales.getTotalValue(model, "count");
};
